export const requiredIndicatorStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
  padding: 12,
  marginBottom: 12,
  borderRadius: 8,
  // Light: the pale amber `warning.light` fill reads well behind the dark `text.dark` message.
  // Dark: `warning.light` is a saturated amber and `text.dark` flips to white — white-on-amber is
  // unreadable, so use the low-alpha `warning.soft` tint (readable white text over the dark panel).
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.warning.soft : palette.warning.light,
};
